import { AddAccountWebComponent } from './component/AddAccountWebComponent';
import { WEB_COMPONENT_ADD_ACCOUNT_PANEL } from '../../webcomponents.constants';

export { AddAccountWebComponent };

window.customElements.define(WEB_COMPONENT_ADD_ACCOUNT_PANEL, AddAccountWebComponent);
